import { FunctionComponent, useEffect } from "react";
import { useTranslation } from "react-i18next";
import { pdfjs } from "react-pdf";

import "react-pdf/dist/Page/AnnotationLayer.css";
import "react-pdf/dist/Page/TextLayer.css";

import { translationKeys } from "../../../models/app-translation-keys";
import { sharedDialog } from "../../Shared/Components/Dialogs/SharedDialog";
import { TermsOfUseDialogContent } from "./TermsOfUseDialogContent/TermsOfUseDialogContent";
import { TermsOfUseDialogFooter } from "./TermsOfUseDialogFooter/TermsOfUseDialogFooter";
import { ITermsOfUseDialogState } from "./termsOfUseDialogTypes.ts";

pdfjs.GlobalWorkerOptions.workerSrc = new URL("pdfjs-dist/build/pdf.worker.min.mjs", import.meta.url).toString();

export interface ITermsOfUseDialogProps {
  dialogId?: string;
  base64PdfDocument: string | null;
  isLoading: boolean;
  onAccept: () => Promise<void> | void;
  onDecline: () => Promise<void> | void;
}

const termsOfUseAndDataPrivacyPolicyKeys = translationKeys.termsOfUseAndDataPrivacyPolicy;

export const TermsOfUseDialog: FunctionComponent<ITermsOfUseDialogProps> = (props: ITermsOfUseDialogProps) => {
  const { t } = useTranslation();

  useEffect(() => {
    sharedDialog.openSharedDialog({
      title: t(termsOfUseAndDataPrivacyPolicyKeys.title),
      onClose: undefined,
      size: "large",
      sharedState: {
        isChecked: false,
        isScrolledToBottom: false,
      } satisfies ITermsOfUseDialogState,
      customContent: () => (
        <TermsOfUseDialogContent base64PdfDocument={props.base64PdfDocument} isLoading={props.isLoading} />
      ),
      customFooter: ({ id }) => (
        <TermsOfUseDialogFooter
          dialogId={id}
          base64PdfDocument={props.base64PdfDocument}
          onAccept={props.onAccept}
          onDecline={props.onDecline}
        />
      ),
      className: "terms-of-use-dialog",
      customDismissBehavior: {
        closeIcon: false,
        escape: false,
        outsideClick: false,
      },
    });
  }, [props.base64PdfDocument]);

  return null;
};
